import axios from '@/axios.js'
let entityURL = ''; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    dashboardRecords: [],
    dashboardRecordsRedGreen: [],
    dashboardRecordsPerSource: [],
    dashboardLineChart:[],
    dashboardProductCategories: [],
    dashboardProductGroups: [],
    dashboardProductBrands: [],
    failing_urls: 0,
    inactive_urls: 0,
    active_urls: 0,
    total_urls: 0,
    total_products: 0,
    total_active_products_with_urls: 0,
    total_inactive_products_with_urls: 0,
}

const getters = {
    getDashboardRecords: (state) => (state.dashboardRecords),
    getDashboardRecordsRedGreen: (state) => (state.dashboardRecordsRedGreen),
    getDashboardRecordsPerSource: (state) => (state.dashboardRecordsPerSource),
    getDashboardLineChart: (state) => (state.dashboardLineChart),
    getDashboardProductCategories: (state) => (state.dashboardProductCategories),
    getDashboardProductGroups: (state) => (state.dashboardProductGroups),
    getDashboardProductBrands: (state) => (state.dashboardProductBrands),
    getTotalUrls: (state) => (state.total_urls),
    getActiveUrls: (state) => (state.active_urls),
    getInactiveUrls: (state) => (state.inactive_urls),
    getFailingUrls: (state) => (state.failing_urls),
    getTotalProducts: (state) => (state.total_products),
    getTotalActiveProductsWithUrls: (state) => (state.total_active_products_with_urls),
    getTotalInactiveProductsWithUrls: (state) => (state.total_inactive_products_with_urls),
}

const actions = {
    async fetchDashboardRecords({ commit }) {
        const response = await axios(`${entityURL}/dashboard`)
        commit('SET_DASHBOARD_RECORDS', response.data)
        commit('SET_FAILING_URLS', response.data.total_failing_urls)
        commit('SET_INACTIVE_URLS', response.data.total_inactive_urls)
        commit('SET_ACTIVE_URLS', response.data.total_active_urls)
        commit('SET_TOTAL_URLS', response.data.total_urls)
        commit('SET_TOTAL_PRODUCTS', response.data.total_products)

        commit('SET_TOTAL_ACTIVE_PRODUCTS_WITH_URLS', response.data.total_active_products_with_urls)
        commit('SET_TOTAL_INACTIVE_PRODUCTS_WITH_URLS', response.data.total_inactive_products_with_urls)
    },

    async fetchDashboardLineChart({ commit }) {
        const response = await axios(`${entityURL}/dashboard-line-chart`)
        commit('SET_DASHBOARD_LINE_CHART', response.data)
    },

    async fetchDashboardProductCategories({ commit }) {
        const response = await axios(`${entityURL}/dashboard-product-categories`)
        commit('SET_DASHBOARD_PRODUCT_CATEGORIES', response.data)
    },

    async fetchDashboardProductGroups({ commit }) {
        const response = await axios(`${entityURL}/dashboard-product-groups`)
        commit('SET_DASHBOARD_PRODUCT_GROUPS', response.data)
    },

    async fetchDashboardProductBrands({ commit }) {
        const response = await axios(`${entityURL}/dashboard-product-brands`)
        commit('SET_DASHBOARD_PRODUCT_BRANDS', response.data)
    },

    async fetchDashboardRecordsRedGreen({ commit }) {
        const response = await axios(`${entityURL}/dashboardRedGreen`)
        commit('SET_DASHBOARD_RECORDS_RED_GREEN', response.data)
    },

    async fetchDashboardRecordsPerSource({ commit }) {
        const response = await axios(`${entityURL}/dashboardPerSource`)
        commit('SET_DASHBOARD_RECORDS_PER_SOURCE', response.data)
    },
}

const mutations = {
    SET_DASHBOARD_RECORDS: (state, data) => (state.dashboardRecords = data),
    SET_DASHBOARD_RECORDS_RED_GREEN: (state, data) => (state.dashboardRecordsRedGreen = data),
    SET_DASHBOARD_RECORDS_PER_SOURCE: (state, data) => (state.dashboardRecordsPerSource = data),
    SET_DASHBOARD_LINE_CHART: (state, data) => (state.dashboardLineChart = data),
    SET_DASHBOARD_PRODUCT_CATEGORIES: (state, data) => (state.dashboardProductCategories = data),
    SET_DASHBOARD_PRODUCT_GROUPS: (state, data) => (state.dashboardProductGroups = data),
    SET_DASHBOARD_PRODUCT_BRANDS: (state, data) => (state.dashboardProductBrands = data),

    SET_FAILING_URLS: (state, data) => (state.failing_urls = data),
    SET_INACTIVE_URLS: (state, data) => (state.inactive_urls = data),
    SET_ACTIVE_URLS: (state, data) => (state.active_urls = data),
    SET_TOTAL_URLS: (state, data) => (state.total_urls = data),
    SET_TOTAL_PRODUCTS: (state, data) => (state.total_products = data),

    SET_TOTAL_ACTIVE_PRODUCTS_WITH_URLS: (state, data) => (state.total_active_products_with_urls = data),
    SET_TOTAL_INACTIVE_PRODUCTS_WITH_URLS: (state, data) => (state.total_inactive_products_with_urls = data),
}


export default { state, mutations, actions, getters }
